import React from "react";

import { WidgetRenderLocation } from "@intelligems/ig-types";
import { IgProgressBar } from "@src/domains/WidgetLibrary/ProgressBar/IgProgressBar";
import { ProgressBarContextProvider } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContextProvider";
import { CartValueInput } from "@src/features/personalizations/components/offerModifications/widgets/CartValueInput";
import { UserInterfaceWidgetPreview as Preview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfaceWidgetPreview";
import { WidgetMoreMenu } from "@src/features/personalizations/components/offerModifications/widgets/WidgetMoreMenu";
import { useDispatch } from "@src/store";
import { setDialog } from "@src/store/slices/global";
import { useUserInterfaceProgressBarConfig } from "@src/store/slices/userInterfaces/selectors";
import { useUserInterfaceProgressBar } from "@src/store/slices/widgets/selectors";

interface ProgressBarPreviewProps {
  variationId: string;
  hideLabel?: boolean;
  renderLocation?: WidgetRenderLocation;
}

export const ProgressBarPreview = ({
  variationId,
  hideLabel,
  renderLocation,
}: ProgressBarPreviewProps) => {
  const dispatch = useDispatch();
  const widget = useUserInterfaceProgressBar(variationId);
  const config = useUserInterfaceProgressBarConfig(variationId);
  const mode =
    widget?.widgetType === "shippingProgressBar" ? "toggle" : "input";

  const handleEdit = () => {
    dispatch(
      setDialog({
        dialog: "offers",
        open: true,
        props: { targetPage: "progressBar" },
      })
    );
  };

  const handleDelete = () => {
    dispatch(
      setDialog({
        dialog: "deleteComponent",
        open: true,
        props: {
          componentType: "progressBar",
          variationId,
          widgetType: widget?.widgetType,
        },
      })
    );
  };

  return (
    <ProgressBarContextProvider config={config} mode={mode}>
      <Preview renderLocation={renderLocation}>
        {!hideLabel && (
          <Preview.Label
            label={renderLocation === "settings" ? "Preview" : "Progress Bar"}
            menu={
              <WidgetMoreMenu onEdit={handleEdit} onDelete={handleDelete} />
            }
            renderLocation={renderLocation}
          >
            <CartValueInput size={"medium"} />
          </Preview.Label>
        )}
        <Preview.Widget device={"desktop"} renderLocation={renderLocation}>
          {config && <IgProgressBar device={"desktop"} config={config} />}
        </Preview.Widget>
      </Preview>
    </ProgressBarContextProvider>
  );
};
